import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Methode from "@/pages/Methode";
import Carnets from "@/pages/Carnets";
import CarnetReader from "@/pages/CarnetReader";
import Jeu from "@/pages/Jeu";
import IleAbondance from "@/pages/IleAbondance";
import MonEspace from "@/pages/MonEspace";
import Admin from "@/pages/Admin";
import Aventures from "@/pages/Aventures";
import AdventureReader from "@/pages/AdventureReader";
import Univers from "@/pages/Univers";
import IleCarrefour from "@/pages/IleCarrefour";
import CarnetsBoutique from "@/pages/CarnetsBoutique";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import CedaBoutique from "@/pages/CedaBoutique";
import MesCeda from "@/pages/MesCeda";
import GiftClaim from "@/pages/GiftClaim";
import ReviewInvite from "@/pages/ReviewInvite";
import { PaymentSuccess, PaymentCancel, PaymentPaypalReturn } from "@/pages/Payment";

function AppRoutes() {
  const location = useLocation();
  // Google OAuth returns to {origin}/...#session_id=... — handle it before normal routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/methode" element={<Methode />} />
      <Route path="/univers" element={<Univers />} />
      <Route path="/univers/ile-de-labondance" element={<IleCarrefour />} />
      <Route path="/boutique/carnets" element={<CarnetsBoutique />} />
      <Route path="/aventures" element={<Aventures />} />
      <Route path="/aventure/:id" element={<AdventureReader />} />
      <Route path="/carnets" element={<Carnets />} />
      <Route path="/carnet/:id" element={<CarnetReader />} />
      <Route path="/jeu" element={<Jeu />} />
      <Route path="/jeu/ile" element={<IleAbondance />} />
      <Route path="/mon-espace" element={<MonEspace />} />
      <Route path="/cadeau/:code" element={<GiftClaim />} />
      <Route path="/avis/:token" element={<ReviewInvite />} />
      <Route path="/mon-espace/ceda" element={<MesCeda />} />
      <Route path="/ceda" element={<CedaBoutique />} />
      <Route path="/connexion" element={<Auth />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/payment/paypal-return" element={<PaymentPaypalReturn />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <AppRoutes />
          </Layout>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
